import { useNavigate } from "react-router-dom";
import { Sparkles, Ticket, Headphones } from "lucide-react";
import { useTranslation } from "react-i18next";

const ICON_MAP = { sparkles: Sparkles, ticket: Ticket, headphones: Headphones };

/**
 * SupportChoiceBar — Contextual support options shown at page bottom or sidebar.
 * Usage: <SupportChoiceBar options={[...]} />
 */
const SupportChoiceBar = ({ options = [], onAiChat }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  if (!options || options.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-4 pt-3 border-t border-[rgba(255,255,255,0.06)]" data-testid="support-choice-bar">
      <span className="text-[#8B95A5] text-[10px] mr-1">{t('needHelp', 'Need help?')}</span>
      {options.map(opt => {
        const Icon = ICON_MAP[opt.icon] || Sparkles;
        return (
          <button
            key={opt.id}
            onClick={() => {
              if (opt.type === "ai_chat" && onAiChat) onAiChat();
              else if (opt.path) navigate(opt.path);
            }}
            className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[10px] font-medium text-[#B8C7D9] bg-[rgba(255,255,255,0.03)] hover:bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.06)] hover:border-[rgba(255,255,255,0.12)] transition-colors"
            data-testid={`support-choice-${opt.id}`}
          >
            <Icon size={11} className="text-[#36A9E1]" />
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default SupportChoiceBar;
